import { defineStore } from 'pinia';
import { ref } from 'vue';

const useCalfSizeStore = defineStore(
  'calfSize',
  () => {
    const shoeSize = ref<string | null>(null);
    const calfCircumference = ref<string | null>(null);

    const setShoeSize = (value: string | null): void => {
      shoeSize.value = value;
    };

    const setCalfCircumference = (value: string | null): void => {
      calfCircumference.value = value;
    };

    return {
      shoeSize,
      calfCircumference,
      setShoeSize,
      setCalfCircumference,
    };
  },
  {
    persist: {
      storage: sessionStorage,
      key: 'calfSize',
    },
  }
);

export default useCalfSizeStore;
